export enum EnumRecursoPerfil {

  Cadastros = 'CadastrosBasicos',
  ManterPAA = 'Manter PAA',
  ManterPEA = 'Manter PEA',
  ManterOPA = 'Manter OPA',
  Configuracoes = 'Configurações',
  Planejamento = 'Planejamento',
  ManterOSA='Manter OSA',
  Auditoria='Auditoria',
  Aprovacoes='Aprovações',
  LogsDoSistema='Logs do Sistema',
  Aberto='Aberto',
  CadastroCategoriaRisco='Cadastro - Categoria Risco',
  //PrePlanejamento='RelacionamentoComUG - PrePlanejamento',
	CadastroRiscos = "Cadastro - Riscos",
	CriteriosAvaliacaoRiscos = "Cadastro - Critérios Avaliação",
  ModeloQuestionario='ModeloQuestionario',
  QuestionarioMaturidade='QuestionarioMaturidade',
  QuestionarioEntentendoEntidade='QuestionarioEntentendoEntidade',
  TipoUniversoAuditavel = 'TipoUniversoAuditavel',
  RiscosChaves = 'RiscosChaves',
  CadastroPapeisTrabalho = 'Cadastro - Papel de Trabalho',
  GestaoRiscosProcessos = 'Gestão de Riscos - Processos',
  SolicitacoesTecnicas = 'Solicitações Técnicas',
  AuditoriaExecucao = 'Auditoria - Execução',
  ServidoresUeci = 'Servidores - UECI',
  PrePlanejamento='Órgãos e Entidades - Pré Planejamento',
  AprovarMatrizPreliminar = 'Aprovar Matriz Preliminar',
  GestaoRiscosModelos = 'Gestão de Riscos - Modelos',
  RolResponsabilidade = 'Rol de Responsabilidade',
  PontosDeControle = 'Pontos de Controle',
  ReluciPlanejamento = 'RELUCI - Planejamento',
  ManterDenuncia = 'Manter Denuncia',
  Denuncia = 'Denúncia',
  PlanoDeAcao = "Plano de Ação",
  Monitoramento = "Monitoramento",
  ManualReluci = "Manual RELUCI",
  ModeloDocumento = 'Integridade - Modelos de Documentos',
  CriteriosAmostragem = "Critérios de Amostragem",
  Administrador = "Administrador",
  ServidorIntegridade = "Servidores Integridade",
  GerenciarServidores = "Gerenciar Servidores",
  GerenciarListas = "Gerenciar Listas",
  GerarDocumento = "Gerar Documento",
  FichaPessoaJuridica = "Ficha Pessoas Jurídicas",
  GerarProcesso = "Gerar Processo",
}
